export const LOCATION = 'api/location'
export const IMAGE = 'api/image'
export const PAYMENT_TRANSACTION = '/api/payment/transaction'
export const ORDER = 'api/order'

// NOTE: LOCATION
export const GET_LOCATION_ORGANIZATIONS = `${LOCATION}/organizations`
export const GET_LOCATION_GOALS = `${LOCATION}/goals`
export const GET_LOCATION_GOAL = `${LOCATION}/goal`
export const GET_LOCATION_VOUCHERS = `${LOCATION}/vouchers`
export const GET_LOCATION_RULES = `${LOCATION}/rules`

// NOTE: FILE
export const DOWNLOAD_IMAGE = `${IMAGE}`

// NOTE: PAYMENT
export const AUTORIZE_TRANSACTION = `${PAYMENT_TRANSACTION}/authorizeonetime`

// NOTE: ORDER
export const GET_ORDER = `${ORDER}`
